<a href="javascript:void(0)" mat-button [matMenuTriggerFor]="menu">
  <ng-content></ng-content>
</a>
<mat-menu #menu="matMenu">
  <a
    mat-menu-item
    *ngFor="let lead of unattemptedLeads; last as last"
    class="h-auto w-auto px-3 pb-2 pt-0 d-flex text-dark"
    [ngClass]="{'border-bottom': !last}"
    [routerLink]="['/borrower/' + lead.borrowerId]"
    style="text-decoration: none; outline: none"
  >

    <!-- left box -->
    <div class="flex-grow-1" style="width: calc(100% - 44px); overflow: hidden">
      <strong><a [routerLink]="['/borrower/' + lead.borrowerId]" class="text-dark" style="text-decoration: none">{{ lead.borrowerName }}</a></strong>

      <div style="line-height: 32px">
        <small class="mr-2">Needs:</small>

        <a
          *ngIf="lead.needs.call"
          [routerLink]="['/borrower/' + lead.borrowerId]"
          class="fa-stack ml-1"
          matTooltip="A call lasting 45 seconds or longer"
          matTooltipPosition="above"
        >
          <i class="fa fa-circle fa-stack-2x" style="color: rgb(195, 240, 249)"></i>
          <i class="fa fa-phone fa-stack-1x" style="color: rgb(75, 92, 96)"></i>
        </a>

        <a
          *ngIf="lead.needs.sms"
          [routerLink]="['/borrower/' + lead.borrowerId]"
          [queryParams]="{pane: 'messages', subpane: 'sms'}"
          class="fa-stack ml-1"
          matTooltip="An outgoing SMS message"
          matTooltipPosition="above"
        >
          <i class="fa fa-circle fa-stack-2x" style="color: rgb(195, 240, 249)"></i>
          <i class="fa fa-commenting fa-stack-1x" style="color: rgb(75, 92, 96)"></i>
        </a>

        <a
          *ngIf="lead.needs.message"
          [routerLink]="['/borrower/' + lead.borrowerId]"
          [queryParams]="{pane: 'messages', subpane: 'email'}"
          class="fa-stack ml-1"
          matTooltip="An outgoing email message"
          matTooltipPosition="above"
        >
          <i class="fa fa-circle fa-stack-2x" style="color: rgb(195, 240, 249)"></i>
          <i class="fa fa-envelope fa-stack-1x" style="color: rgb(75, 92, 96)"></i>
        </a>

      </div>
    </div>

    <!-- right box -->
    <a class="pl-3 d-flex align-items-center" [routerLink]="['/borrower/' + lead.borrowerId]" style="text-decoration: none">
      <i class="fa fa-angle-right fa-2x text-muted"></i>
    </a>

  </a>
</mat-menu>
